// Copyright 2022 The Chromium Authors. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.

export * as AnimationFrames from './AnimationFramesHandler.js';
export * as Animations from './AnimationHandler.js';
export * as AsyncJSCalls from './AsyncJSCallsHandler.js';
export * as AuctionWorklets from './AuctionWorkletsHandler.js';
export * as DOMStats from './DOMStatsHandler.js';
export * as ExtensionTraceData from './ExtensionTraceDataHandler.js';
export * as Flows from './FlowsHandler.js';
export * as Frames from './FramesHandler.js';
export * as GPU from './GPUHandler.js';
export * as ImagePainting from './ImagePaintingHandler.js';
export * as Initiators from './InitiatorsHandler.js';
export * as Invalidations from './InvalidationsHandler.js';
export * as LargestImagePaint from './LargestImagePaintHandler.js';
export * as LargestTextPaint from './LargestTextPaintHandler.js';
export * as LayerTree from './LayerTreeHandler.js';
export * as LayoutShifts from './LayoutShiftsHandler.js';
export * as Memory from './MemoryHandler.js';
export * as Meta from './MetaHandler.js';
export * as NetworkRequests from './NetworkRequestsHandler.js';
export * as PageFrames from './PageFramesHandler.js';
export * as PageLoadMetrics from './PageLoadMetricsHandler.js';
export * as Renderer from './RendererHandler.js';
export * as Samples from './SamplesHandler.js';
export * as Screenshots from './ScreenshotsHandler.js';
export * as Scripts from './ScriptsHandler.js';
export * as SelectorStats from './SelectorStatsHandler.js';
export * as UserInteractions from './UserInteractionsHandler.js';
export * as UserTimings from './UserTimingsHandler.js';
export * as Warnings from './WarningsHandler.js';
export * as Workers from './WorkersHandler.js';
